import React from 'react';

import { useTranslation } from 'react-i18next';

import { Chip, ChipColor } from '@pkg/components/Sections/Profile/Chip';
import { ReactComponent as Arrow } from '@pkg/components/Sections/Profile/icons/arrow.svg';
import { useFloorGameActivity, useGetGroup, useGroupActivity } from '@pkg/hooks';

import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { GroupActivityLoaderWrapper } from './styles';

export const GroupActivityLoader = () => {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);
    const { data } = useGetGroup({ isAuthenticated });
    const { isDisplayed, setIsDisplayed } = useGroupActivity(data?.id || '');
    const { t } = useTranslation('groups');

    useFloorGameActivity();

    const getNewActivity = () => {
        window.scrollTo({ top: 0 });
        setIsDisplayed(false);
    };

    if (!isDisplayed) return null;

    return (
        <GroupActivityLoaderWrapper>
            <Chip color={ChipColor.Blur} onClick={getNewActivity}>
                <Chip.Interior>
                    <Chip.AttachedIcon>
                        <Arrow />
                    </Chip.AttachedIcon>
                    <Chip.Label content={t('groups_new_activity')} />
                </Chip.Interior>
            </Chip>
        </GroupActivityLoaderWrapper>
    );
};
